var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("actions.placeholders"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: { slot: "item-title", to: "/super-admin/dashboard" },
                  slot: "item-title",
                },
                [_vm._v(_vm._s(_vm.$t("general.home")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    slot: "item-title",
                    to: "/super-admin/listOfActions",
                  },
                  slot: "item-title",
                },
                [_vm._v(_vm._s(_vm.$t("actions.list_of_actions")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [_vm._v(_vm._s(_vm.$t("actions.placeholders")))]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("SingleInvoiceRow", {
        attrs: { fetchData: _vm.fetchData, tableDivId: _vm.tableDivId },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c("div", { staticClass: "table-actions mt-5" }, [
            _c("p", { staticClass: "table-stats" }, [
              _vm._v(_vm._s(_vm.$t("general.showing")) + ": "),
              _c("b", [_vm._v(_vm._s(_vm.placeholders.length))]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "table-component",
            {
              ref: "table",
              attrs: {
                "show-filter": false,
                data: _vm.placeholders,
                "table-class": "table",
              },
            },
            [
              _c("table-column", {
                attrs: { label: _vm.$t("actions.defination"), show: "key" },
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: { label: _vm.$t("actions.value"), show: "value" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }